import React from 'react';
import './styles.css';

const Chip = ({ children, ...props }) => {
  return (
    <div className="cb-chip" {...props}>
      {children}
    </div>
  );
};

export default Chip;
